import type { PromoUploadStatusType } from '@entities/adCampaign';

export const getStorablePromoStatuses = (statuses: PromoUploadStatusType[]): PromoUploadStatusType[] =>
  statuses
    .filter((status) => status.promoId && !status.isLoading && !status.error)
    .map((status) => {
      const storableStatus = {
        ...status,
        sourcefiles: status.sourcefiles ?? [],
      } as PromoUploadStatusType & {
        chosen?: boolean;
        filtered?: boolean;
        selected?: boolean;
      };

      delete storableStatus.file;
      delete storableStatus.error;
      delete storableStatus.chosen;
      delete storableStatus.filtered;
      delete storableStatus.selected;

      return storableStatus;
    });
